import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const CreativeIcon = {
  name: 'CreativeIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-creative"
    }, ctx.data]), [
      h("g", {
        attrs: {
          opacity: "0.7"
        }
      }, [
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1.85742 2.64331H10.3574V11.1433H1.85742V2.64331ZM3.35742 4.14331V9.64331H8.85742V4.14331H3.35742Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M14.1016 1.68823L22.3119 3.88819L20.112 12.0986L11.9016 9.8986L14.1016 1.68823ZM15.1622 3.52535L13.7387 8.83794L19.0513 10.2614L20.4748 4.94885L15.1622 3.52535Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1.85742 13.6433H10.3574V22.1433H1.85742V13.6433ZM3.35742 15.1433V20.6433H8.85742V15.1433H3.35742Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.8574 13.6433H21.3574V22.1433H12.8574V13.6433ZM14.3574 15.1433V20.6433H19.8574V15.1433H14.3574Z",
            fill: "currentColor"
          }
        })
      ])
    ]);
  }
};

export default CreativeIcon; 